import { Component } from '@angular/core';

@Component({
  templateUrl: './license.component.html',
  styleUrls: ['./license.component.css'],
})
export class LicenseComponent {

  constructor() { }

}
